// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__-AMgw","signatureButtonsRight":"ModalSign_signatureButtonsRight__3dzYg"};